// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.huauOsgTaAEBhW6GgmxN{border:1px solid var(--border-neutral-default);background:var(--background-primary-Inverted-primary);border-radius:6px;align-items:center;width:-webkit-fit-content;width:fit-content;max-width:170px;padding:4px 8px;display:flex}.PH3z5kIwfeEq1doGjLZK{gap:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"groupItem": `huauOsgTaAEBhW6GgmxN`,
	"groupsContainer": `PH3z5kIwfeEq1doGjLZK`
};
export default ___CSS_LOADER_EXPORT___;
